<auth-template>
  <div class="content-container">
    <div class="content-space">
      <header class="header">
        <img class="logo" alt="GoReact" src="https://staticassets.goreact.com/logo-goreact-dash-2022.svg">
      </header>
      @if (loading$ | async) {
        <div class="loading-group-info">
          <i class="ficon-spinner ficon-spin ficon-2x"></i>
          <p translate="sign-up-student_loading-group-information"></p>
        </div>
      }

      <!--Error Message -->
      @if (error$ | async) {
        <div class="error-message">
          <h4 class="large-label" translate="sign-up-big-label-group-unavailable"></h4>
          <p class="invalid-course" translate="sign-up-group-link-invalid-or-expired"></p>
          <p class="contact-instructor" translate="sign-up-contact-your-instructor-label"></p>
          <div class="button-container">
            <button type="button" class="primary-btn" [attr.aria-label]="'common_close' | translate" (click)="toLogin()"
              translate="common_login">
            </button>
          </div>
        </div>
      }
      <!-- End of Error Message -->

      <!-- Group Message -->
      @if (showConfirmation$ | async) {
        <div  class="confirmation-message {{!isCourseInvite ? 'course-invite' : ''}}">
          <h4 data-cy="group-confirmation-sub-heading" translate="{{headerTranslationKey}}"></h4>
          <div class="text-container">
            <span class="group-confirmation-sub-heading" translate="{{subHeaderTranslationKey}}"></span>
          </div>
          @if (invite$ | async) {
            <div class="text-container">
              <span translate="sign-up-confirmation-role-info"></span>
              <span class="role">{{ (invite$ | async).role }}</span>
            </div>
          }
          <div class="text-container">
            <span translate="{{getGroupTypeNameTranslation}}"></span>
            <span class="group-name">{{ (group$ | async).title }}</span>
          </div>
          <div class="text-container">
            <span>{{ 'owner' | translate }}:</span>
            <span class="creator-name">{{ ' ' + (group$ | async).name }}</span>
            <a href="mailto:{{ (group$ | async).email }}" class="creator-email" [attr.aria-label]="'sign-up-email-the-instructor' | translate">{{ (group$ | async).email
            }}</a>
          </div>
          @if (isCourseInvite) {
            <div class="text-container footer-info">
              <span translate="sign-up-student-confirmation-are-you-sure"></span>
              <span translate="sign-up-student-confirmation-contact-your-instructor"></span>
            </div>
          }
          <div class="button-container">
            <button type="button" class="primary-btn" data-cy="group-confirm-continue"
              (click)="confirmGroup()" translate="common_register" autofocus>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</auth-template>
